/* ============================================================
   cart-page.js — CART-3: Product Recommendations Upsell
   Fetches /recommendations/products for the first cart item
   and renders up to 4 product tiles into #cart-upsell.
   Self-contained; no external dependencies.
   ============================================================ */

(function () {
    'use strict';

    var container = document.getElementById('cart-upsell');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    if (!productId || productId === '') return;

    /* Money formatter — mirrors Shopify's {{ price | money }} for the
       store's default currency (USD). Adjust locale/currency if needed. */
    function formatMoney(cents) {
        var dollars = cents / 100;
        return dollars.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        });
    }

    /* Build a single product tile */
    function buildTile(product) {
        var url = '/products/' + product.handle;
        var image = product.featured_image
            ? product.featured_image + '&width=300'
            : null;
        var title = product.title || '';
        var price = formatMoney(product.price);

        var tile = document.createElement('div');
        tile.className = 'cart-upsell-tile';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'cart-upsell-tile__img-wrap';
        if (image) {
            var img = document.createElement('img');
            img.src = image;
            img.alt = title;
            img.loading = 'lazy';
            img.width = 300;
            imgWrap.appendChild(img);
        }
        tile.appendChild(imgWrap);

        var body = document.createElement('div');
        body.className = 'cart-upsell-tile__body';

        var titleLink = document.createElement('a');
        titleLink.href = url;
        titleLink.className = 'cart-upsell-tile__title';
        titleLink.textContent = title;
        body.appendChild(titleLink);

        var priceEl = document.createElement('div');
        priceEl.className = 'cart-upsell-tile__price';
        priceEl.textContent = price;
        body.appendChild(priceEl);

        /* Quick-add to cart via Shopify Cart API */
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-upsell-tile__btn';
        btn.textContent = 'Add to cart';
        btn.setAttribute('data-variant-id', product.variants[0].id);
        btn.addEventListener('click', function () {
            addToCart(product.variants[0].id, btn);
        });
        body.appendChild(btn);

        tile.appendChild(body);
        return tile;
    }

    /* Add variant to cart, then redirect to /cart to refresh totals */
    function addToCart(variantId, btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
        })
        .then(function () {
            window.location.href = '/cart';
        })
        .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
        });
    }

    /* Fetch recommendations and render */
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
        .then(function (res) {
            if (!res.ok) throw new Error('Recommendations fetch failed');
            return res.json();
        })
        .then(function (data) {
            var products = (data && data.products) ? data.products : [];
            if (products.length === 0) return;

            var heading = document.createElement('p');
            heading.className = 'cart-upsell-title';
            heading.textContent = 'You may also like';
            container.appendChild(heading);

            var grid = document.createElement('div');
            grid.className = 'cart-upsell-grid';
            products.forEach(function (product) {
                grid.appendChild(buildTile(product));
            });
            container.appendChild(grid);
        })
        .catch(function () {
            /* Silently suppress — upsell is non-critical */
        });
})();
